import ActionTypes from "../constants/ActionTypes";
import API from "../api/";
// import API, { getBreadcrumbsForSinglePostType } from "../api/";
import { setTagsCounter } from "./tagsCounter";
import _ from "lodash";
// import Config from "../constants/Config.js";

const fetchPageRequest = () => ({
    type: ActionTypes.FETCH_PAGE_REQUEST,
});

const fetchPageSuccess = page => ({
    type: ActionTypes.FETCH_PAGE_SUCCESS,
    page,
});

const fetchPageFail = error => ({
    type: ActionTypes.FETCH_PAGE_FAIL,
    error,
});

export const fetchPage =
    (path = "/", query = "") =>
    async (dispatch, getState) => {
        dispatch(fetchPageRequest());
        return API.fetchPage(path, query)
            .then(async data => {
                let page = { ...data, path };
                if (data.acf?.event_host_type?.ID) {
                    const eventHostTypeData = data.acf.event_host_type;
                    await API.fetchEventHostType(eventHostTypeData.ID).then(
                        data => {
                            if (data.id) {
                                page = {
                                    ...page,
                                    event_host_type_data: {
                                        name: data.title,
                                        link: data.acf.website_url,
                                        imageUrl: data.acf.logo.url,
                                    },
                                };
                            }
                        }
                    );
                }
                // // If there are no breadcrumbs - attempt to load them from the listing page
                // // for this post type
                // if (!page.breadcrumbs || page.post_type === "researchcentres") {
                //     if (page.post_type !== "page") {
                //         page.breadcrumbs =
                //             await getBreadcrumbsForSinglePostType(
                //                 page.post_type,
                //                 page.breadcrumbs
                //             );
                //     } else {
                //         page.breadcrumbs = Config.defaultBreadcrumbs;
                //     }
                // }
                dispatch(fetchPageSuccess(page));
                const { tagsCounter } = getState();
                const tags = page.tags_input || [];
                const newTagsCounter = tagsCounter.tags;
                tags.forEach(tag => {
                    const slug = _.kebabCase(tag);
                    newTagsCounter[slug] = newTagsCounter[slug]
                        ? newTagsCounter[slug] + 1
                        : 1;
                });
                dispatch(setTagsCounter(newTagsCounter));
            })
            .catch(error => {
                console.error(error);
                dispatch(fetchPageFail(error));
            });
    };

export const updateCurrentPagePath = (path = "/") => ({
    type: ActionTypes.UPDATE_CURRENT_PAGE_PATH,
    path,
});

export const updateFiltersList = filters => ({
    type: ActionTypes.UPDATE_FILTERS_LIST,
    filters,
});

export const updateFeaturedList = featured => ({
    type: ActionTypes.UPDATE_FEATURED_LIST,
    featured,
});
